import type { BaseDataItem, SVGDataItem, VectorImageData } from '@wix/thunderbolt-becky-types'
import type { CatharsisArgs } from '@wix/thunderbolt-catharsis'
import { isValidShape } from './shapeIdsNode'
import type { ImageXDataItem } from '@wix/thunderbolt-components'

const isVectorImage = (dataItem: BaseDataItem) => dataItem.type === 'VectorImage'
const isSVGItem = (dataItem: BaseDataItem) => dataItem.type === 'SVGItem'

const isShapeItem = (aspect: string, dataItem: BaseDataItem): dataItem is VectorImageData | SVGDataItem =>
	(aspect === 'document_data' && isVectorImage(dataItem)) || isSVGItem(dataItem)

const isImageXItem = (aspect: string, dataItem: BaseDataItem): dataItem is ImageXDataItem =>
	aspect === 'document_data' && dataItem.type === 'ImageX'

export const getInvalidationHandler = (set: Set<string>): CatharsisArgs['onInvalidation'] => (path, get) => {
	const [, aspect] = path
	if (aspect === 'shapeIds' || aspect === 'cursorShapeIds') {
		const value = get<Array<string> | undefined>(path)
		if (value) {
			value.forEach((id) => set.add(id))
		}
	}

	// TODO: Remove this in an experiment to and use only components mappers to find svgIds.
	const dataItem = get<BaseDataItem>(path)
	if (dataItem) {
		if (isShapeItem(aspect, dataItem) && isValidShape(dataItem.svgId)) {
			set.add(dataItem.svgId)
		} else if (isImageXItem(aspect, dataItem) && isValidShape(dataItem.mask?.svgId)) {
			set.add(dataItem.mask?.svgId)
		}
	}
}
